"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageJsonDetails = exports.packageDetails = exports.PACKAGE_TYPES = void 0;
var tslib_1 = require("tslib");
var validatePackageString_1 = require("./validatePackageString");
exports.PACKAGE_TYPES = {
    slice: 'slices',
    application: 'applications',
    template: 'templates',
    ui: 'ui',
    unknown: 'unknown',
};
var getType = function (type) {
    return Object.prototype.hasOwnProperty.call(exports.PACKAGE_TYPES, type)
        ? exports.PACKAGE_TYPES[type]
        : exports.PACKAGE_TYPES.unknown;
};
var getSnakeCaseName = function (name) { return name.replace(/-/g, '_'); };
var packageDetails = function (packageString) {
    var _a, _b;
    var _c = (_a = packageString.split) === null || _a === void 0 ? void 0 : _a.call(packageString, '/'), scope = _c[0], name = _c[1], version = _c[2];
    (0, validatePackageString_1.validatePackageString)(scope, name, version);
    var type = (_b = name.split('-')) === null || _b === void 0 ? void 0 : _b[0];
    return {
        scope: scope,
        name: name,
        version: version !== null && version !== void 0 ? version : 'latest',
        type: getType(type),
        nameSnakeCase: getSnakeCaseName(name),
    };
};
exports.packageDetails = packageDetails;
var packageJsonDetails = function (packageJson) {
    var name = packageJson.name, version = packageJson.version;
    var packageString = name + "/" + version;
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, (0, exports.packageDetails)(packageString)), { packageString: packageString });
};
exports.packageJsonDetails = packageJsonDetails;
//# sourceMappingURL=package-details.js.map